import { lazy, Suspense, useMemo } from 'react'
import { useFeatureSelector } from '@/platform/state/hooks'
import { hasAllPermissions } from '@/platform/authorization/permissions'
import type { FeatureManifest } from '@/platform/navigation/featureManifest'
import { FeatureLoader } from '@/platform/ui/FeatureLoader'
import { FeatureBoundary } from './FeatureBoundary'

export function FeatureRoute({ feature }: { feature: FeatureManifest }) {
  const authorization = useFeatureSelector((state) => state.session.authorization)
  const isAdmin = useFeatureSelector((state) => state.session.user?.role === 'admin' || state.session.user?.role === 'super_admin')
  const isSuperAdmin = useFeatureSelector((state) => state.session.user?.role === 'super_admin')
  const allowed = hasAllPermissions(authorization, feature.requiredPermissions)
  const Entry = useMemo(() => lazy(feature.load), [feature.load])
  if (!allowed || (feature.adminOnly && !isAdmin) || (feature.superAdminOnly && !isSuperAdmin)) return <section className="access-denied"><h1>Chưa được cấp quyền</h1><p>Tài khoản của bạn chưa có quyền truy cập chức năng này. Hãy liên hệ quản trị viên.</p></section>
  return <FeatureBoundary key={feature.id}><Suspense fallback={<FeatureLoader />}><Entry /></Suspense></FeatureBoundary>
}
